
document.addEventListener( "DOMContentLoaded", () => {
  const classesOf = ( el, attr ) => ( el.dataset[ attr ] || "" ).split( /\s+/ ).filter( Boolean );

  // --- DESKTOP TABS ---
  const desktopTabs = document.querySelectorAll( ".tech-tab" );
  const desktopContents = document.querySelectorAll( ".tech-tab-content" );

  desktopTabs.forEach( tab => {
    tab.addEventListener( "click", () => {
      const id = tab.dataset.tab;

      desktopTabs.forEach( t => {
        t.classList.remove( ...classesOf( t, "activeClass" ), "pointer-events-none",
          "cursor-default" );
        t.classList.add( ...classesOf( t, "inactiveClass" ) );
      } );

      tab.classList.remove( ...classesOf( tab, "inactiveClass" ) );
      tab.classList.add( ...classesOf( tab, "activeClass" ), "pointer-events-none",
        "cursor-default" );

      desktopContents.forEach( c => {
        c.style.display = c.dataset.tabContent === id ? "block" : "none";
      } );
    } );
  } );

  // --- MOBILE ACCORDION ---
  const accBtns = document.querySelectorAll( ".accordion-btn" );
  const accContents = document.querySelectorAll( ".accordion-content" );

  accBtns.forEach( btn => {
    btn.addEventListener( "click", () => {
      const id = btn.dataset.accordion;
      const content = document.querySelector( `[data-accordion-content="${ id }"]` );

      const isOpen = !content.classList.contains( "hidden" );

      // Close all accordions
      accContents.forEach( c => c.classList.add( "hidden" ) );
      accBtns.forEach( b => {
        b.classList.remove( ...classesOf( b, "activeClass" ) );
        b.classList.add( ...classesOf( b, "inactiveClass" ) );
        b.querySelector( ".accordion-icon" ).classList.remove(
          "hidden" ); // show icon
      } );

      // Open clicked one, unless it was already open
      if ( !isOpen ) {
        content.classList.remove( "hidden" );
        btn.classList.remove( ...classesOf( btn, "inactiveClass" ) );
        btn.classList.add( ...classesOf( btn, "activeClass" ) );

        // Hide the icon for the open accordion
        btn.querySelector( ".accordion-icon" ).classList.add( "hidden" );

        // Scroll the whole technologies section to the top of the viewport
        const section = document.getElementById( "technologies" );
        if ( section ) {
          section.scrollIntoView( {
            behavior: "smooth",
            block: "start"
          } );
        }
      }
    } );
  } );
} );
